module.exports = __webpack_public_path__ + "img/zunzheng-address.d3dd51a1.png";